import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";


@Component({
  templateUrl: "resources.component.html",
  styleUrls: ["resources.component.scss"],
})
export class ResourcesComponent implements OnInit {
  currentUrl: string;

  constructor(private location: Location, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.url.subscribe(() => (this.currentUrl = this.location.path()));
  }
}
